export class ComboFlash {
  private el: HTMLElement;

  constructor() {
    this.el = document.getElementById('combo-flash')!;
  }

  show(combo: number, damage: string) {
    const flashText = this.getFlashText(combo);
    this.el.innerHTML = `
      <div style="
        color: #00f0ff;
        font-size: ${Math.min(36 + combo * 2, 80)}px;
        font-weight: bold;
        font-family: 'Arial Black', Arial, sans-serif;
        text-shadow: 0 0 20px rgba(0,240,255,0.8), 0 0 60px rgba(0,240,255,0.4);
        animation: comboAnim 0.6s ease-out;
        white-space: nowrap;
      ">${flashText}</div>
      <div style="
        color: #ffea00;
        font-size: ${Math.min(20 + combo, 40)}px;
        font-weight: bold;
        font-family: Arial, sans-serif;
        text-shadow: 0 0 15px rgba(255,234,0,0.6);
        animation: comboAnim 0.6s ease-out 0.1s both;
      ">${damage}</div>
    `;
    this.el.style.display = 'block';

    setTimeout(() => {
      this.el.style.display = 'none';
      this.el.innerHTML = '';
    }, 800);
  }

  private getFlashText(combo: number): string {
    if (combo >= 50) return '🔥 传说连击!';
    if (combo >= 30) return '⚡ 史诗连击!!';
    if (combo >= 20) return '💥 超级连击!';
    if (combo >= 10) return '✨ 连续暴击!';
    if (combo >= 5) return '🔥 连击!';
    return `${combo}x 连击`;
  }
}

// Inject CSS animation
const style = document.createElement('style');
style.textContent = `
  @keyframes comboAnim {
    0% { transform: scale(0.3) rotate(-10deg); opacity: 0; }
    50% { transform: scale(1.3) rotate(3deg); opacity: 1; }
    100% { transform: scale(1) rotate(0deg); opacity: 1; }
  }
`;
document.head.appendChild(style);
